export default function PHP_reference_Error() {
  return (
    <div>
      <h1>PHP_reference_Error</h1>
    </div>
  );
}
